// A real WebGL check: "WebGLRenderingContext" in window is true even when WebGL is disabled or blocklisted.
// The probe context is released right away so it does not count against the browser's context limit.
export default function hasWebGL() {
  try {
    const probe = document.createElement("canvas");
    const gl = (probe.getContext("webgl2") || probe.getContext("webgl")) as WebGLRenderingContext | null;
    gl?.getExtension("WEBGL_lose_context")?.loseContext();
    return !!gl;
  } catch {
    return false;
  }
}
